import hashObject from 'object-hash';

/**
 * Create a unique hash ID for an input object.
 */
export function createHashIdGenerator<T extends object>({
    seed,
}: {
    /** Seed to avoid conflicts with other hash IDs */
    seed: string;
}) {
    return (input: { props: T }): string => {
        return hashObject({ seed, props: input.props });
    };
}
